const defaultOptionsReactQuery = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
}

export default defaultOptionsReactQuery
